export default "__VITE_ASSET__Bswkj3WE__"